
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"18","fill":"#fff","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.75 18H2.25A2.25 2.25 0 010 15.75V2.25A2.25 2.25 0 012.25 0h19.5A2.25 2.25 0 0124 2.25v13.5A2.25 2.25 0 0121.75 18zM5.25 2.625a2.625 2.625 0 100 5.25 2.625 2.625 0 000-5.25zM3 15h18V9.75l-4.102-4.102a.563.563 0 00-.796 0L9.75 12 7.148 9.398a.563.563 0 00-.796 0L3 12.75V15z","fill":"#DCDCDC"}})])
          )
        }
      }
    